import { render, staticRenderFns } from "./BrokerCommission.vue?vue&type=template&id=504fd94e"
import script from "./BrokerCommission.vue?vue&type=script&lang=js"
export * from "./BrokerCommission.vue?vue&type=script&lang=js"
import style0 from "./BrokerCommission.vue?vue&type=style&index=0&id=504fd94e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports